module.exports = ".imageProgress {\r\n    text-align: center;\r\n    margin: 8px 0;\r\n}\r\n\r\napp-simple-image, app-base-video {\r\n    max-width: 480px;\r\n    display: block;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/commons/chat/chat-file/chat-file.component.css
// module id = ./src/app/commons/chat/chat-file/chat-file.component.css
// module chunks = main